module.exports = __webpack_public_path__ + "img/location-3-ended.e17e7ba8.png";